import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {makeStyles} from '@material-ui/core/styles';
import {Icon} from 'front-onceforall-core';

const statData = {
  users: {
    color: '#E3EBF2',
    link: '/organisation/users'
  },
  projects: {
    color: '#ECE9F7',
    link: '/projects'
  },
  clients: {
    color: '#EDE2EF',
    link: '/clients'
  }
};

const skeletonStyle = makeStyles({
  root: {
    backgroundColor: '#e5e7e8'
  }
});

function SmallStatView({label, stat}) {
  const skeletonClasses = skeletonStyle();

  return (
    <div
      className="d-flex justify-content-between align-items-center p-3"
      style={{backgroundColor: statData[label].color, borderRadius: 5}}
    >
      <div>
        <div className="w-100">
          <h3 className="mb-2">
            <Translate value={`dashboard.stats.${label}`}/>
          </h3>
        </div>
        <div>
          {stat.loading ?
            <Skeleton
              classes={{root: skeletonClasses.root}}
              variant="rect"
              height={30}
              width={29}
            /> :
            <strong className="font-size-xl">{stat.count}</strong>
          }
        </div>
      </div>
      <Tooltip title={<Translate value={`dashboard.stats.link.${label}`}/>}>
        <Link to={statData[label].link}>
          <Icon
            icon="eye"
            size={18}
            color="tertiary"
          />
        </Link>
      </Tooltip>
    </div>
  );
}

SmallStatView.propTypes = {
  label: PropTypes.oneOf(['users', 'clients', 'projects']).isRequired,
  stat: PropTypes.object.isRequired
};

export default SmallStatView;
